import React from "react";
import { ShieldCheck, Landmark, Star } from "lucide-react";

const START_YEAR = 2010;

export default function TrustBar() {
  const years = new Date().getFullYear() - START_YEAR;

  return (
    <section
      data-testid="trust-bar"
      className="relative border-t border-white/5"
      style={{
        background:
          "linear-gradient(180deg, #0A1024 0%, #0B1225 100%)",
      }}
    >
      {/* subtle gold hairline */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

      <div className="max-w-6xl mx-auto px-6 md:px-12 py-14 md:py-16">
        <div className="text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#D4AF37]/50" />
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Segurança & Confiança
            </span>
            <span className="w-8 h-px bg-[#D4AF37]/50" />
          </div>

          {/* Years operating badge */}
          <div
            data-testid="trust-years"
            className="inline-flex items-baseline gap-3 mb-8"
          >
            <span className="font-serif-ag text-[#D4AF37] text-5xl md:text-6xl font-light leading-none">
              {years}+
            </span>
            <span className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-[#A3ABB8]">
              anos de mercado
              <br className="hidden md:block" />
              <span className="text-white/70 normal-case tracking-normal text-[13px] block mt-1">
                Atuando desde {START_YEAR}
              </span>
            </span>
          </div>

          {/* Main trust statement */}
          <p
            data-testid="trust-statement"
            className="font-serif-ag text-white/95 text-lg md:text-xl lg:text-[1.45rem] font-light leading-relaxed max-w-4xl mx-auto tracking-tight"
          >
            Nossa reputação é construída com{" "}
            <span className="text-[#D4AF37] italic">transparência</span>:
            consulte o <span className="text-white">Reclame Aqui</span> para ver
            nosso compromisso com o cliente. Operamos em total conformidade com
            as normas do{" "}
            <span className="text-white">Banco Central do Brasil</span> para
            consórcios.
          </p>

          {/* Pillars strip */}
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4 max-w-3xl mx-auto">
            <div className="flex flex-col items-center gap-2">
              <Star size={16} strokeWidth={1.3} className="text-[#D4AF37]" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-[#A3ABB8]">
                Reputação verificável
              </span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Landmark size={16} strokeWidth={1.3} className="text-[#D4AF37]" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-[#A3ABB8]">
                Conformidade BACEN
              </span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <ShieldCheck size={16} strokeWidth={1.3} className="text-[#D4AF37]" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-[#A3ABB8]">
                Operação regulada
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* bottom hairline transition */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/8 to-transparent" />
    </section>
  );
}
